module.exports = __webpack_public_path__ + "415e5ea2170873140bee6fba35433076.woff";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/fonts/Avenir-Book.woff
// module id = 649
// module chunks = 0